/* Grass Mats Co — header behaviour: sticky header, mega menu, predictive search, mobile drawer, basket count. */
(function () {
  'use strict';
  var root = document.documentElement;

  function money(cents, cur) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur || 'GBP' }).format(cents / 100); }
    catch (e) { return '£' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shortTitle(t) { return String(t || '').split(' | ')[0].split(' – ')[0]; }

  /* ---------- Top bar: rotate messages on small screens ---------- */
  function initTopbar(tb) {
    if (!tb || tb.__gmc) return; tb.__gmc = true;
    var items = tb.querySelectorAll('[data-gmc-tb-msg]');
    if (items.length < 2) { if (items[0]) items[0].classList.add('is-on'); return; }
    var i = 0;
    items[0].classList.add('is-on');
    setInterval(function () {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4000);
  }

  /* ---------- Header ---------- */
  function initHeader(hd) {
    if (!hd || hd.__gmc) return; hd.__gmc = true;
    var section = hd.closest('.shopify-section') || hd;
    var scrim = hd.querySelector('[data-gmc-scrim]');
    var cur = hd.getAttribute('data-currency') || 'GBP';
    var openItem = null, openTimer, closeTimer;
    var holdOpen = function () { return openItem || hd.classList.contains('is-searching') || root.classList.contains('gmc-lock'); };

    // Sticky: hide on scroll down, show on scroll up; expose header height to the page.
    var lastY = window.scrollY, hidden = false, ticking = false;
    function setVars() {
      var h = section.offsetHeight;
      root.style.setProperty('--gmc-header-h', h + 'px');
      root.style.setProperty('--gmc-sticky-offset', (hidden ? 0 : h) + 'px');
    }
    function onScroll() {
      var y = window.scrollY, h = section.offsetHeight;
      section.classList.toggle('is-scrolled', y > 10);
      if (hd.getAttribute('data-smart-sticky') === 'true' && !holdOpen()) {
        if (y > h + 60 && y > lastY + 6 && !hidden) { hidden = true; section.classList.add('is-hidden'); setVars(); }
        else if ((y < lastY - 6 || y <= h) && hidden) { hidden = false; section.classList.remove('is-hidden'); setVars(); }
      }
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    window.addEventListener('resize', setVars);
    setVars();

    // Mega menu
    var items = Array.prototype.slice.call(hd.querySelectorAll('[data-gmc-nav-item]'));
    function open(item) {
      if (openItem === item) return;
      if (openItem) close(openItem, true);
      var panel = item.querySelector('[data-gmc-mega]');
      if (!panel) return;
      openItem = item;
      item.classList.add('is-open');
      panel.hidden = false;
      item.querySelector('[data-gmc-nav-top]').setAttribute('aria-expanded', 'true');
      if (scrim) scrim.classList.add('is-on');
    }
    function close(item, swap) {
      if (!item) return;
      var panel = item.querySelector('[data-gmc-mega]');
      item.classList.remove('is-open');
      if (panel) panel.hidden = true;
      var top = item.querySelector('[data-gmc-nav-top]');
      if (top) top.setAttribute('aria-expanded', 'false');
      if (openItem === item) openItem = null;
      if (!swap && scrim) scrim.classList.remove('is-on');
    }
    var coarse = window.matchMedia('(hover: none)').matches;
    items.forEach(function (item) {
      var top = item.querySelector('[data-gmc-nav-top]');
      var panel = item.querySelector('[data-gmc-mega]');
      if (!panel) return;
      item.addEventListener('mouseenter', function () { clearTimeout(closeTimer); openTimer = setTimeout(function () { open(item); }, openItem ? 0 : 120); });
      item.addEventListener('mouseleave', function () { clearTimeout(openTimer); closeTimer = setTimeout(function () { close(item); }, 180); });
      top.addEventListener('click', function (e) {
        // Touch screens: first tap opens the panel, second tap follows the link.
        if (coarse && openItem !== item) { e.preventDefault(); open(item); }
      });
      top.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault(); open(item);
          var first = panel.querySelector('a'); if (first) first.focus();
        }
      });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(item); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) { var t = openItem.querySelector('[data-gmc-nav-top]'); close(openItem); t.focus(); }
    });
    if (scrim) scrim.addEventListener('click', function () { close(openItem); });

    // Basket count + total
    var badge = hd.querySelector('[data-gmc-cart-count]'), total = hd.querySelector('[data-gmc-cart-total]');
    function refreshCart() {
      fetch((window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (badge) { badge.textContent = c.item_count; badge.setAttribute('data-count', c.item_count); }
          if (total) total.textContent = money(c.total_price, cur);
        }).catch(function () {});
    }
    root.addEventListener('cart:refresh', refreshCart);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

    initSearch(hd.querySelector('[data-gmc-search]'), hd, cur);
    initDrawer(hd);
  }

  /* ---------- Predictive search ---------- */
  var SVG_SEARCH = '<svg class="gmc-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>';
  var SVG_CLOCK = '<svg class="gmc-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></svg>';
  var SVG_TIP = '<svg class="gmc-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M9 18h6"/><path d="M10 21h4"/><path d="M12 3a6 6 0 0 0-4 10.5c.7.7 1 1.5 1 2.5h6c0-1 .3-1.8 1-2.5A6 6 0 0 0 12 3z"/></svg>';

  // Area in m² of one unit from a variant title, e.g. "1.0m x 1.5m x 23mm", "6ft x 4ft", "36inch x 36inch".
  function parseArea(title) {
    var t = String(title || '').toLowerCase().replace(/×/g, 'x'), m;
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*m(?:\s*wide)?\s*x\s*(\d+(?:\.\d+)?)\s*m(?!m)/))) return +m[1] * +m[2];
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*(?:ft|feet|')\s*x\s*(\d+(?:\.\d+)?)\s*(?:ft|feet|')/))) return m[1] * 0.3048 * m[2] * 0.3048;
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*(?:inch|in|")\s*x\s*(\d+(?:\.\d+)?)\s*(?:inch|in|")/))) return m[1] * 0.0254 * m[2] * 0.0254;
    if ((m = t.match(/(\d{3,4})\s*mm\s*x\s*(\d{3,4})\s*mm/))) return (m[1] / 1000) * (m[2] / 1000);
    return 0;
  }
  function thickness(title) {
    var all = String(title || '').toLowerCase().match(/\d+\s*mm/g);
    return all ? all[all.length - 1].replace(/\s/g, '') : '';
  }
  function highlight(text, q) {
    var safe = esc(text);
    var words = String(q || '').toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; })
      .map(function (w) { return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    return words.length ? safe.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>') : safe;
  }

  function initSearch(form, hd, cur) {
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('.gmc-search__box');
    var panel = form.querySelector('[data-gmc-search-panel]');
    var popular = form.querySelector('[data-gmc-search-popular]');
    var status = form.querySelector('[data-gmc-search-status]');
    var clearBtn = form.querySelector('[data-gmc-search-clear]');
    var micBtn = form.querySelector('[data-gmc-search-mic]');
    var backBtn = form.querySelector('[data-gmc-search-back]');
    var url = form.getAttribute('data-suggest-url') || '/search/suggest';
    var searchUrl = form.getAttribute('action') || '/search';
    var cartAdd = (window.routes && window.routes.cartAddUrl) || '/cart/add';
    var placeholder = input.getAttribute('placeholder');
    var mobile = window.matchMedia('(max-width: 989px)');
    var tips = [];
    try { tips = JSON.parse(form.querySelector('[data-gmc-search-tips]').textContent) || []; } catch (e) {}
    var timer, ctrl, active = -1;
    var RKEY = 'gmc_recent_searches';

    function getRecent() { try { return JSON.parse(localStorage.getItem(RKEY)) || []; } catch (e) { return []; } }
    function saveRecent(q) {
      q = String(q || '').trim(); if (q.length < 2) return;
      try {
        var r = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
        r.unshift(q); localStorage.setItem(RKEY, JSON.stringify(r.slice(0, 6)));
      } catch (e) {}
    }
    function searchLink(q) { return esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&amp;options%5Bprefix%5D=last'; }

    function tipFor(q) {
      var s = ' ' + String(q).toLowerCase() + ' ';
      for (var i = 0; i < tips.length; i++) {
        var ks = tips[i].k || [];
        for (var j = 0; j < ks.length; j++) { var k = String(ks[j]).trim(); if (k && s.indexOf(k) > -1) return tips[i]; }
      }
      return null;
    }
    function tipHtml(t) {
      return '<div class="gmc-search__tip"><span class="gmc-search__tip-ic">' + SVG_TIP + '</span><div><b>' + esc(t.t) + '</b>' +
        (t.x ? '<p>' + esc(t.x) + '</p>' : '') + (t.u && t.l ? '<a href="' + esc(t.u) + '">' + esc(t.l) + ' →</a>' : '') + '</div></div>';
    }

    function links() { return Array.prototype.slice.call(panel.querySelectorAll('a:not(.gmc-search__opt)')); }
    function setActive(i) {
      var ls = links(); if (!ls.length) return;
      active = (i + ls.length) % ls.length;
      ls.forEach(function (a, n) { a.classList.toggle('is-active', n === active); });
      ls[active].scrollIntoView({ block: 'nearest' });
    }
    function show(html) {
      panel.innerHTML = html; panel.hidden = false; active = -1;
      hd.classList.add('is-searching'); form.classList.add('is-open'); input.setAttribute('aria-expanded', 'true');
      if (mobile.matches) root.classList.add('gmc-lock');
    }
    function hide() {
      panel.hidden = true; hd.classList.remove('is-searching'); form.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('[data-gmc-drawer].is-open')) root.classList.remove('gmc-lock');
    }
    function syncClear() { if (clearBtn) clearBtn.hidden = !input.value; }

    function emptyState() {
      var html = '', rec = getRecent();
      if (rec.length) {
        html += '<div class="gmc-search__row"><p class="gmc-search__label">Recent searches</p><button type="button" class="gmc-search__mini" data-gmc-recent-clear>Clear</button></div><div class="gmc-search__chips">';
        rec.forEach(function (r) { html += '<a href="' + searchLink(r) + '" data-q="' + esc(r) + '">' + SVG_CLOCK + esc(r) + '</a>'; });
        html += '</div>';
      }
      show(html + (popular ? popular.innerHTML : ''));
    }

    // Thickness chips and sold-out flag from a list of variants.
    function metaHtml(variants, available) {
      var thicks = [];
      variants.forEach(function (v) { var t = thickness(v.title); if (t && thicks.indexOf(t) < 0) thicks.push(t); });
      return thicks.slice(0, 3).map(function (t) { return '<i>' + esc(t) + '</i>'; }).join('') + (available ? '' : '<i class="is-out">Sold out</i>');
    }

    // Predictive search only returns the variants that matched the query, so rows start with an
    // Options link and are upgraded from the full product JSON (all variants) once it loads.
    var productCache = {};
    function productJson(u) {
      var key = String(u).split('?')[0];
      if (!productCache[key]) {
        productCache[key] = fetch(key + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .catch(function () { delete productCache[key]; return null; });
      }
      return productCache[key];
    }
    function enrich(li) {
      productJson(li.getAttribute('data-gmc-url')).then(function (pj) {
        if (!pj || !li.isConnected) return;
        var vs = pj.variants || [];
        var meta = li.querySelector('[data-gmc-meta]');
        if (meta) meta.innerHTML = metaHtml(vs, pj.available);
        // Lowest price per m² across all sizes.
        var unit = 0;
        vs.forEach(function (v) { var a = parseArea(v.title); if (a > 0 && v.price > 0 && (!unit || v.price / a < unit)) unit = v.price / a; });
        var em = li.querySelector('.gmc-search__item em');
        if (unit && em) {
          var u = em.querySelector('.gmc-search__unit');
          if (!u) { u = document.createElement('span'); u.className = 'gmc-search__unit'; em.appendChild(u); }
          u.textContent = money(Math.round(unit), cur) + '/m²';
        }
        var opt = li.querySelector('.gmc-search__opt');
        if (opt && vs.length === 1 && vs[0].available) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'gmc-search__add'; b.textContent = 'Add';
          b.setAttribute('data-gmc-quick-add', vs[0].id);
          b.setAttribute('aria-label', 'Add ' + shortTitle(pj.title) + ' to basket');
          opt.parentNode.replaceChild(b, opt);
        }
      });
    }

    function productRow(p, q) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
      var variants = p.variants || [];
      var price = parseFloat(p.price_min || p.price);
      var varies = p.price_max && p.price_min && p.price_max !== p.price_min;
      var area = parseArea(p.title);
      for (var i = 0; i < variants.length && !area; i++) area = parseArea(variants[i].title);
      var priceHtml = isNaN(price) ? '' : (varies ? '<small>from</small>' : '') + money(Math.round(price * 100), cur) +
        (area > 0 ? '<span class="gmc-search__unit">' + money(Math.round(price / area * 100), cur) + '/m²</span>' : '');
      return '<li class="gmc-search__prow" data-gmc-url="' + esc(p.url) + '"><a class="gmc-search__item" href="' + esc(p.url) + '" data-q="' + esc(q) + '">' +
        (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="60" height="60">' : '') +
        '<span class="gmc-search__txt"><span class="gmc-search__name">' + highlight(shortTitle(p.title), q) + '</span>' +
        '<span class="gmc-search__meta" data-gmc-meta>' + metaHtml(variants, p.available) + '</span></span>' +
        '<em>' + priceHtml + '</em></a><a class="gmc-search__opt" href="' + esc(p.url) + '" tabindex="-1">Options</a></li>';
    }

    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], pages = r.pages || [];
      var sugs = (r.queries || []).filter(function (s) { return s.text && s.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
      // Skip empty leftover "sc-" collections and duplicate titles.
      var seen = {};
      var cols = (r.collections || []).filter(function (c) {
        var key = String(c.title).toLowerCase();
        if (/\/collections\/sc-/.test(c.url) || seen[key]) return false;
        seen[key] = true; return true;
      });
      var html = '', tip = tipFor(q);
      if (tip) html += tipHtml(tip);
      if (sugs.length) {
        html += '<ul class="gmc-search__sugs">';
        sugs.forEach(function (s) { html += '<li><a class="gmc-search__sug" href="' + searchLink(s.text) + '" data-q="' + esc(s.text) + '">' + SVG_SEARCH + '<span>' + highlight(s.text, q) + '</span></a></li>'; });
        html += '</ul>';
      }
      if (products.length) {
        html += '<p class="gmc-search__label">Products</p><ul class="gmc-search__list">';
        products.forEach(function (p) { html += productRow(p, q); });
        html += '</ul>';
      }
      if (cols.length || pages.length) {
        html += '<p class="gmc-search__label">Categories &amp; help</p><div class="gmc-search__chips">';
        cols.concat(pages).forEach(function (c) { html += '<a href="' + esc(c.url) + '" data-q="' + esc(q) + '">' + esc(c.title) + '</a>'; });
        html += '</div>';
      }
      if (!products.length && !cols.length && !pages.length && !sugs.length) {
        html += '<p class="gmc-search__empty">No matches for “' + esc(q) + '”. Try a job like “driveway”, “playground” or “horse gateway”, or <a href="tel:' + esc(form.getAttribute('data-phone') || '') + '">call us</a> and we’ll help.</p>';
      }
      html += '<a class="gmc-search__all" href="' + searchLink(q) + '" data-q="' + esc(q) + '">See all results for “' + esc(q) + '”</a>';
      show(html);
      Array.prototype.forEach.call(panel.querySelectorAll('[data-gmc-url]'), enrich);
      if (status) status.textContent = products.length ? products.length + ' products found' : 'No products found';
    }

    function query(q) {
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      box.classList.add('is-loading');
      fetch(url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=query,product,collection,page&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last', { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { box.classList.remove('is-loading'); if (input.value.trim() === q) render(q, d); })
        .catch(function (e) { if (!e || e.name !== 'AbortError') box.classList.remove('is-loading'); });
    }
    function onInput() {
      var q = input.value.trim();
      syncClear();
      clearTimeout(timer);
      if (q.length < 2) { box.classList.remove('is-loading'); emptyState(); return; }
      timer = setTimeout(function () { query(q); }, 160);
    }

    function quickAdd(btn) {
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch(cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-gmc-quick-add')), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓'; btn.classList.add('is-done');
          root.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () { btn.textContent = 'Try again'; btn.disabled = false; });
    }

    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) query(input.value.trim()); else emptyState();
    });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); links()[active].click(); }
      else if (e.key === 'Escape') { hide(); input.blur(); }
    });
    panel.addEventListener('click', function (e) {
      var add = e.target.closest('[data-gmc-quick-add]');
      if (add) { e.preventDefault(); quickAdd(add); return; }
      if (e.target.closest('[data-gmc-recent-clear]')) {
        e.preventDefault();
        try { localStorage.removeItem(RKEY); } catch (err) {}
        emptyState(); input.focus(); return;
      }
      var a = e.target.closest('a');
      if (a && a.hasAttribute('data-q')) saveRecent(a.getAttribute('data-q'));
    });
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); return; }
      saveRecent(input.value);
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; syncClear(); emptyState(); input.focus(); });
    if (backBtn) backBtn.addEventListener('click', function () { hide(); input.blur(); });

    // Voice search where the browser supports it.
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SR && micBtn) {
      micBtn.hidden = false;
      var rec = null;
      micBtn.addEventListener('click', function () {
        if (rec) { rec.stop(); return; }
        rec = new SR(); rec.lang = 'en-GB'; rec.interimResults = true; rec.maxAlternatives = 1;
        box.classList.add('is-listening'); input.setAttribute('placeholder', 'Listening…');
        rec.onresult = function (ev) {
          var t = ''; for (var i = 0; i < ev.results.length; i++) t += ev.results[i][0].transcript;
          input.value = t; onInput();
        };
        rec.onend = rec.onerror = function () { box.classList.remove('is-listening'); input.setAttribute('placeholder', placeholder); rec = null; };
        rec.start();
      });
    }

    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    form.addEventListener('focusout', function (e) { if (e.relatedTarget && !form.contains(e.relatedTarget)) hide(); });
    syncClear();
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer(hd) {
    var drawer = document.querySelector('[data-gmc-drawer]');
    var burger = hd.querySelector('[data-gmc-burger]');
    if (!drawer || !burger) return;
    var closeBtn = drawer.querySelector('button[data-gmc-drawer-close]');
    function openD() {
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true'); root.classList.add('gmc-lock');
      setTimeout(function () { closeBtn.focus(); }, 50);
    }
    function closeD() {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false'); root.classList.remove('gmc-lock');
      burger.focus();
    }
    burger.addEventListener('click', openD);
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-gmc-drawer-close]'), function (b) { b.addEventListener('click', closeD); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeD();
      if (e.key === 'Tab') {
        var f = drawer.querySelectorAll('a, button, summary, input');
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // Anchor links inside the drawer (e.g. #faq on the same page) should close it.
    drawer.addEventListener('click', function (e) { var a = e.target.closest('a'); if (a && a.hash && a.pathname === location.pathname) closeD(); });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gmc-topbar]'), initTopbar);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gmc-header]'), initHeader);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
